"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpisFormInputParanthesizedTooltip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var RichTextPreTag_1 = require("./RichTextPreTag");
var IpisFormInputParanthesizedTooltip = function (props) {
    return (0, jsx_runtime_1.jsx)(RichTextPreTag_1.RichTextPreTag, { html: props.html, className: props.className });
};
exports.IpisFormInputParanthesizedTooltip = IpisFormInputParanthesizedTooltip;
